import * as React from 'react';
import '../App.css';

export default function WatchNowContainer(isVisible) {
    

  return (
    <div id='watch-now-movie-container' style={{ width: '100%' }}>

        <div id='watch-now-movie-container-frame' >
            <iframe
                src="https://customer-l5dnifyghh0aa878.cloudflarestream.com/8d7628fb20beeeb03c4f4ca6d2968244/iframe?poster=https%3A%2F%2Fcustomer-l5dnifyghh0aa878.cloudflarestream.com%2F8d7628fb20beeeb03c4f4ca6d2968244%2Fthumbnails%2Fthumbnail.jpg%3Ftime%3D2m38s%26height%3D600"
                style= {{ border: 'none', position: 'absolute', top: '0', left: '0', height: '100%', width: '100%' }}
                allow="accelerometer; gyroscope; autoplay; encrypted-media; picture-in-picture;"
                allowFullScreen={true}
            ></iframe>
        </div>
	
    </div>
  );
}